<template>
    <div class="statement-list">
        <status-tabs :status.sync="status" :statusList="statusList" :funcName="funcName"></status-tabs>

        <search-tool ref="searchTool" :status="status" :statusList="statusList" :funcName="funcName"
            :searchForm="searchForm" :searchList="searchList" :searchForm_transfer="searchForm_transfer"
            :advanceSearchFields="advanceSearchFields" listName="statement" :loading="loading" :inputPlaceholder="inputPlaceholder" :selected="selectList.length">
        </search-tool>

        <div class="table" :style="{ height: height }">
            <el-table :data="tableData" ref="tableData" height="100%" row-key="id"
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" align="center"></el-table-column>
                <el-table-column align="left" label="Month" prop="month" width="120">
                </el-table-column>
                <el-table-column align="right" label="Opening Balance" prop="opening_balance">
                    <template slot-scope="scope">
                        <div>
                            {{ '$' + formatAmount(scope.row.opening_balance) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="right" label="Order Count" prop="order_count">
                </el-table-column>
                <el-table-column align="right" label="Goods Amount" prop="goods_amount">
                    <template slot-scope="scope">
                        <div class="col-amount" :style="{ color: scope.row.goods_amount > 0 ? '#f56c6c' : '' }">
                            {{ '$' + formatAmount(scope.row.goods_amount) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="right" label="Shipping Amount" prop="shipping_amount">
                    <template slot-scope="scope">
                        <div class="col-amount" :style="{ color: scope.row.shipping_amount > 0 ? '#f56c6c' : '' }">
                            {{ '$' + formatAmount(scope.row.shipping_amount) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="right" label="Other" prop="other_amount">
                    <template slot-scope="scope">
                        <div class="col-amount" :style="{ color: scope.row.other_amount > 0 ? '#f56c6c' : '' }">
                            {{ '$' + formatAmount(scope.row.other_amount) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="right" label="Recharge Amount" prop="recharge_amount">
                    <template slot-scope="scope">
                        <div class="col-amount" :style="{ color: scope.row.recharge_amount > 0 ? '#635cff' : '' }">
                            <span v-if="scope.row.recharge_amount > 0">+</span>
                            {{ '$' + formatAmount(scope.row.recharge_amount) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="right" label="Closing Balance" prop="closing_balance">
                    <template slot-scope="scope">
                        <div class="col-balance">
                            {{ '$' + formatAmount(scope.row.closing_balance) }}
                        </div>
                    </template>
                </el-table-column>
                <el-empty :image-size="120" slot="empty">
                    <img slot="image" src="@/assets/image/empty-data.svg" />
                </el-empty>
            </el-table>
        </div>
        <pagination :paginationData="paginationData" @paginationChange="paginationChange" :funcName="funcName">
        </pagination>
    </div>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { infoTagsMixins } from "@/utils/infoTagsMixins.js";
import { tableMixins } from "@/utils/tableMixins.js";
export default {
    mixins: [infoTagsMixins, tableMixins],
    data() {
        return {
            inputPlaceholder: "Keywords include Month、Company",
            searchForm: {
                keyword: "",
                start_date: "",
                end_date: "",
            },
            searchForm_transfer: {},
            funcName: "statement",
            selectList: [],
            advanceSearchFields: {
                start_date: {
                    label: "Start Date",
                    type: "date",
                },
                end_date: {
                    label: "End Date",
                    type: "date",
                },
            },
        };
    },
    methods: {
        formatAmount(amount) {
            if (amount === null || amount === undefined || amount === "") {
                return "0.00";
            }
            return parseFloat(amount).toFixed(2);
        },
        statement(page) {
            this.loading = true;
            page ? (this.paginationData.page = 1) : "";
            cmofferApi
                .statement(
                    {
                        ...this.paginationData,
                        ...this.searchForm,
                        menu_id: this.menu_id,
                        status: this.status,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.tableData = res.data;
                        this.paginationData.total = res.total;
                        this.statusList = res.ext.tabs;
                        this.menuAuth = res.ext.op_auth;
                        this.closeDrawer();
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        clean() {
            this.searchForm = {
                keyword: "",
                start_date: "",
                end_date: "",
            };
            this.searchForm_transfer = {};
        },
        handleSelectionChange(val) {
            this.selectList = [];
            for (let i in val) {
                this.selectList.push(val[i].id);
            }
        },
        searchTags(params) {
            this.searchForm[params.key] = params.value;
        },
        closeTagsItem(key) {
            this.searchForm[key] = "";
        },
        closeTagsAll() {
            this.clean();
        },
        async initialize() {
            await this.statement();
        },
    },
    activated() {
        this.initialize();
    },
    components: {},
    computed: {
        searchList() {
            return [
                {
                    label: this.$i18n.locale == "zh" ? "开始日期" : "Start Date",
                    key: "start_date",
                    type: "date",
                    props: {
                        type: "month",
                        format: "yyyy-MM",
                        valueFormat: "yyyy-MM",
                    },
                },
                {
                    label: this.$i18n.locale == "zh" ? "结束日期" : "End Date",
                    key: "end_date",
                    type: "date",
                    props: {
                        type: "month",
                        format: "yyyy-MM",
                        valueFormat: "yyyy-MM",
                    },
                },
                {
                    label: this.$i18n.locale == "zh" ? "关键字" : "Keyword",
                    key: "keyword",
                    type: "input",
                },
            ];
        },
    },
    watch: {
        searchForm: {
            handler(newValue) {
                for (let k in newValue) {
                    let v = newValue[k];
                    if (!!v) {
                        this.hasSearchCondition = true;
                        return;
                    }
                }
                this.hasSearchCondition = false;
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>
<style lang="scss">
.statement-list {
    width: 100%;
    height: 100%;
    background: #fff;

    .table {
        margin: 0 15px !important;
        padding: 0 !important;
        width: auto !important;
        height: calc(100% - 120px);

        .el-scrollbar__wrap {
            overflow-x: hidden;
        }

        &.has-search-condition {
            height: calc(100% - 192px);
        }

        .col-amount {
            color: var(--col-color);
        }

        .col-balance {
            font-weight: 600;
            color: #303133;
        }
    }
}
</style>
